export default {
  home: '/',
  cryptoTaxes: '/crypto_taxes',
  iframeMessageLog: '/iframe_message_log',
  settings: '/settings',
  apiTesting: '/api_testing',
  backgroundCheckTesting: '/background_check_testing',
}
